@import '../../../../styles/teamscale_tables';
@import '../../../../styles/teamscale_variables';

.findings-table-container {
	min-width: 900px;
}

:global(.ui.selectable.table).findings-table {
	thead {
		max-width: 100%;
	}

	& table thead tr {
		th {
			white-space: pre-wrap !important;
			overflow: hidden;
		}
	}

	.selected-resizable-table-row {
		background-color: @tsFindingTableRowBackground !important;

		&:hover {
			background-color: @tsFindingTableRowBackground !important;
		}

		/** Re-assessment findings maintain their background color upon hovering */

		&.negative:hover {
			background-color: @tsFindingTableRowBackground !important;
		}
	}

	& tbody tr td {
		&.resizable-table-message-column {
			> div {
				display: flex;

				> i {
					flex: 0 0 auto;
				}

				> a {
					flex-shrink: 1;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}

			> a:visited {
				color: @LinkColorVisited !important;

				> span > code {
					color: @LinkColorVisited !important;
				}
			}
		}

		&.path-column {
			white-space: nowrap !important;
			color: @linkColor !important;
		}
	}
}

.strike-trough {
	text-decoration: line-through;
}

.select-all-checkbox-container,
.select-checkbox-container {
	margin-right: 16px;
	vertical-align: middle !important;
	flex: 0 0;
}

.select-all-checkbox-container {
	margin-left: 6px;
}

.select-checkbox-container {
	margin-left: 3px;
}

.table-scroll-box {
	overflow-x: auto; /* Show scrollbars only when needed */
	height: fit-content; /* Use as much space as the table needs (as long as it fits comfortably on the screen) */
	max-height: calc(100vh - 370px); /* Use a maximum of the full viewport minus approx. the topbar + filter section */
}

.finding-assessment-border {
	border-left: 3px solid transparent !important;

	&.border-yellow {
		border-left: 3px solid @tsYellow !important;
	}

	&.border-red {
		border-left: 3px solid @tsRed !important;
	}
}
